import { h } from "preact";
import { useState, useContext, useRef } from "preact/hooks";

import CommentsAction from "./CommentsAction";
import LoadReplies from "./LoadReplies";
import Reply from "./Reply";
import ReplyBox from "./ReplyBox";

import {
  addOverlay,
  reactionsCount,
  removeOverlay,
  timeAgo,
} from "../lib/helper";
import { Context, setUserInfoAction, changeId } from "../lib/globalState";
import ContextMenu from "./ContextMenu";
import { useOnClickOutside } from "../lib/preactfire";
import UserReactionMenu from "./UserReactionMenu";

export default function Comment({ comment, children }) {
  const {
    id,
    timestamp,
    content,
    user_name,
    profile_img,
    replies,
    user_id,
  } = comment;
  const repliesArray =
    replies &&
    replies
      .sort((a, b) =>
        a.timestamp < b.timestamp ? -1 : b.timestamp < a.timestamp ? 1 : 0
      )
      .map((x) => x.comment_id);

  const { dispatch } = useContext(Context);

  const [showReplies, loadReplies] = useState(false);
  const [loadingReplies, setLoadingReplies] = useState(false);
  const [repliesLoaded, setRepliesLoaded] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [toggleReaction, setToggleReaction] = useState(false);

  const wrapperRef = useRef();

  useOnClickOutside(wrapperRef, () => setToggleReaction(false));

  const popUserModal = () => {
    removeOverlay();
    dispatch(
      setUserInfoAction(
        {
          user_name,
          profile_img,
          replies,
          user_id,
        },
        true
      )
    );
    dispatch(changeId(id, true));
  };

  return (
    <div>
      <div className="comment-item">
        <div className="comment-content-wrapper">
          <div className="comment-user">
            <img
              src={profile_img}
              className="comment-user-img"
              onClick={popUserModal}
            />
            <div className="comment-user-wrapper">
              <span
                className="comment-user-name"
                id="comment-user-name"
                onClick={popUserModal}
              >
                {user_name}
              </span>
              <span className="comment-ts">
                {timeAgo(timestamp < 0 ? -timestamp : timestamp)}
              </span>
            </div>

            <div
              className="right-menu"
              onClick={(e) => {
                if (e.currentTarget.classList.contains("show-right-menu")) {
                  document.querySelectorAll(".right-menu").forEach((el) => {
                    el.classList.remove("show-right-menu");
                  });
                  e.currentTarget.classList.remove("show-right-menu");
                  removeOverlay();
                } else {
                  document.querySelectorAll(".right-menu").forEach((el) => {
                    el.classList.remove("show-right-menu");
                  });
                  e.currentTarget.classList.add("show-right-menu");
                  addOverlay();
                }
              }}
            >
              <svg viewBox="0 0 128 512">
                <path d="M64 208c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM16 104c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm0 304c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48z" />
              </svg>
              <ContextMenu obj={comment} />
            </div>
          </div>
          <div
            className="comment-text"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: content }}
          />
          <div className="comment-action main-action">
            <div
              id="comment_action_cointainer"
              className="comment-share-cointainer"
            >
              <CommentsAction id={id} obj={comment} />
              <div className="d-flex comment-action-replies">
                {reactionsCount(comment) > 0 && (
                  <div
                    ref={wrapperRef}
                    className="d-flex"
                    onClick={() => {
                      addOverlay();
                      setToggleReaction(!toggleReaction);
                    }}
                  >
                    {toggleReaction && <UserReactionMenu obj={comment} />}
                    <span className="show-hide-reply">
                      <svg
                        viewBox="0 0 512 512"
                        style="height: 0.75rem; margin-right: 0.25rem"
                      >
                        <path d="M437.02 74.98C388.668 26.63 324.38 0 256 0S123.332 26.63 74.98 74.98 0 187.62 0 256s26.628 132.668 74.98 181.02S187.62 512 256 512s132.668-26.63 181.02-74.98S512 324.38 512 256s-26.628-132.668-74.98-181.02zM256 481.524c-124.354 0-225.524-101.17-225.524-225.524S131.646 30.476 256 30.476 481.524 131.646 481.524 256 380.354 481.524 256 481.524zm-55.378-293.128c-24.953-24.955-65.556-24.953-90.5 0a15.24 15.24 0 0 0 0 21.55c5.952 5.95 15.6 5.95 21.55 0 13.072-13.07 34.34-13.07 47.4 0a15.19 15.19 0 0 0 10.774 4.464c3.9 0 7.8-1.488 10.774-4.464a15.24 15.24 0 0 0 0-21.55zm201.262 0c-24.953-24.953-65.556-24.955-90.5 0a15.24 15.24 0 0 0 0 21.55c5.952 5.95 15.6 5.95 21.55 0 13.07-13.07 34.338-13.072 47.4 0a15.19 15.19 0 0 0 10.774 4.464c3.9 0 7.8-1.488 10.774-4.464a15.24 15.24 0 0 0 0-21.55zm-10.774 78.78H120.9a15.24 15.24 0 0 0-15.238 15.238c0 82.902 67.447 150.35 150.35 150.35s150.35-67.447 150.35-150.35a15.24 15.24 0 0 0-15.238-15.238zM256 402.286c-60.938 0-111.402-45.703-118.9-104.635h237.8c-7.508 58.932-57.972 104.635-118.9 104.635z" />
                      </svg>
                      {reactionsCount(comment)}
                    </span>
                  </div>
                )}
                <LoadReplies
                  replies={replies}
                  loadReplies={loadReplies}
                  loadingReplies={loadingReplies}
                  setLoadingReplies={setLoadingReplies}
                  repliesLoaded={repliesLoaded}
                  toggle={toggle}
                  setToggle={setToggle}
                />
              </div>
            </div>
          </div>

          {/* Reply Box */}
          <ReplyBox id={id} posterName={user_name} />

          {children}
        </div>
      </div>
      {/* Replies Wrapper */}
      {showReplies && (
        <div
          class="reply-wrapper"
          style={(!repliesLoaded || toggle) && "margin-top: 0"}
        >
          {repliesArray.map((reply, index) => (
            <Reply
              key={index}
              userId={user_id}
              posterName={user_name}
              setLoadingReplies={setLoadingReplies}
              setRepliesLoaded={setRepliesLoaded}
              toggle={toggle}
              id={reply.split("/")[reply.split("/").length - 1]}
            />
          ))}
        </div>
      )}
    </div>
  );
}
